import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaThLarge, FaList, FaPlus, FaEye, FaSpinner } from "react-icons/fa";
import { formatDate } from "../../_helper/utils/utils";

const ReceiptList = ({ receipts, onSelectReceipt, pharmacy_id, isLoading }) => {
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState("tile"); // "tile" or "list"

  return (
    <div className="bg-gray-100 min-h-screen p-6">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Receipts</h2>
        <div className="flex items-center space-x-4">
          <button
            className={`flex items-center px-4 py-2 rounded-lg shadow ${
              viewMode === "tile"
                ? "bg-green-600 text-white"
                : "bg-gray-200 text-gray-800 hover:bg-gray-300"
            }`}
            onClick={() => setViewMode("tile")}
          >
            <FaThLarge className="mr-2" />
          </button>
          <button
            className={`flex items-center px-4 py-2 rounded-lg shadow ${
              viewMode === "list"
                ? "bg-green-600 text-white"
                : "bg-gray-200 text-gray-800 hover:bg-gray-300"
            }`}
            onClick={() => setViewMode("list")}
          >
            <FaList className="mr-2" />
          </button>
          <button
            className="flex items-center bg-green-600 text-white px-4 py-2 rounded-lg shadow hover:bg-green-700 transition"
            onClick={() =>
              navigate(
                `/new/pharmacy/receipt/create?pharmacy_id=${pharmacy_id}`
              )
            }
          >
            <FaPlus className="mr-2" />
            Create Receipt
          </button>
        </div>
      </div>

      {/* Content Rendering */}
      {receipts?.length > 0 ? (
        viewMode === "tile" ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {receipts.map((receipt) => (
              <div
                key={receipt?.id}
                onClick={() => onSelectReceipt && onSelectReceipt(receipt?.id)}
                className="bg-white rounded-lg shadow-lg p-4 cursor-pointer hover:shadow-xl transition border border-gray-200"
              >
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  Invoice: {receipt?.invoice_no}
                </h3>
                <p className="text-sm text-gray-600">
                  <strong>Supplier:</strong> {receipt?.supplier_name}
                </p>
                <p className="text-sm text-gray-600">
                  <strong>Date:</strong> {formatDate(receipt?.invoice_date)}
                </p>
                <p className="text-sm text-gray-600">
                  <strong>Total Amount:</strong> ₹ {receipt?.grand_total}
                </p>
                <div className="mt-4">
                  <button
                    className="flex items-center text-green-600 hover:text-green-800 text-sm font-medium"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/new/pharmacy/receipt/${receipt.id}`);
                    }}
                  >
                    <FaEye className="mr-2" />
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <table className="table-auto w-full text-left border-collapse">
              <thead className="bg-gray-200">
                <tr>
                  <th className="px-4 py-2">Invoice Number</th>
                  <th className="px-4 py-2">Supplier Name</th>
                  <th className="px-4 py-2">Date</th>
                  <th className="px-4 py-2">Total Amount</th>
                  <th className="px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {receipts.map((receipt) => (
                  <tr
                    key={receipt.id}
                    className="border-t hover:bg-gray-100 transition"
                    onClick={() =>
                      onSelectReceipt && onSelectReceipt(receipt.id)
                    }
                  >
                    <td className="px-4 py-2">{receipt?.invoice_no}</td>
                    <td className="px-4 py-2">{receipt?.supplier_name}</td>
                    <td className="px-4 py-2">
                      {formatDate(receipt?.invoice_date)}
                    </td>
                    <td className="px-4 py-2">₹ {receipt?.grand_total}</td>
                    <td className="px-4 py-2">
                      <button
                        className="flex items-center text-green-600 hover:text-green-800 text-sm font-medium"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/new/pharmacy/receipt/${receipt.id}`);
                        }}
                      >
                        <FaEye className="mr-2" />
                        View Details
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      ) : !isLoading ? (
        <div className="flex flex-col items-center justify-center h-40 text-gray-500">
          <p className="text-lg font-medium">No receipts found</p>
          <p className="text-sm">Try adding a new receipt.</p>
        </div>
      ) : null}

      {/* Loader shown below data when fetching new data */}
      {isLoading && (
        <div className="flex justify-center items-center mt-4">
          <FaSpinner className="animate-spin text-green-600 text-4xl" />
        </div>
      )}
    </div>
  );
};

export default ReceiptList;
